<template>
  <div class="app-date-field">
    <div v-if="label" class="field-label">
      <v-icon v-if="labelIcon" size="18">{{ labelIcon }}</v-icon>
      <span>{{ label }}</span>
    </div>

    <v-date-input
      v-model="model"
      prepend-icon=""
      autocomplete="off"
      :class="fieldClass"
      :variant="variant"
      :flat="flat"
      :hide-details="hideDetails"
      :min="minDate"
      :max="maxDate"
      v-bind="fieldAttrs"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, useAttrs } from "vue";

defineOptions({
  inheritAttrs: false,
});

const model = defineModel<Date | string | null>();

const props = withDefaults(
    defineProps<{
    variant?: "solo" | "filled" | "outlined" | "plain" | "solo-filled" | "solo-inverted" | "underlined";
    flat?: boolean;
    hideDetails?: boolean | "auto";
    label?: string;
    labelIcon?: string;
    minDate?: Date | string;
    maxDate?: Date | string;
  }>(),
  {
    variant: "solo",
    flat: true,
    hideDetails: "auto",
    label: "",
    labelIcon: "",
    minDate: undefined,
    maxDate: undefined,
  },
);

const attrs = useAttrs();
const fieldClass = computed(() => ["app-date-field__input", attrs.class]);

const fieldAttrs = computed(() => {
  const { class: _class, ...rest } = attrs;
  return rest;
});
</script>

<style scoped>
.app-date-field {
  width: 100%;
}

.field-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--color-subtitle);
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 6px;
  padding: 0 10px;
}

.app-date-field__input {
  --v-input-control-height: 48px;
  --v-input-padding-top: 0px;
  --v-field-padding-top: 0px;
  --v-field-padding-bottom: 0px;
  --v-field-input-padding-top: 0px;
  --v-field-input-padding-bottom: 0px;
  --v-field-padding-start: 12px;
  --v-field-padding-end: 12px;
}

.app-date-field__input :deep(.v-field) {
  border: 1px solid #eaeaea;
}

.app-date-field__input :deep(.v-field__input) {
  font-size: 0.875rem;
}

.app-date-field__input :deep(.v-input--density-default .v-field--variant-outlined),
.app-date-field__input :deep(.v-input--density-default .v-field--single-line),
.app-date-field__input :deep(.v-input--density-default .v-field--no-label) {
  --v-field-padding-bottom: 0px !important;
}

.app-date-field__input :deep(.v-input--density-default .v-field--variant-solo),
.app-date-field__input :deep(.v-input--density-default .v-field--variant-solo-inverted),
.app-date-field__input :deep(.v-input--density-default .v-field--variant-solo-filled),
.app-date-field__input :deep(.v-input--density-default .v-field--variant-filled) {
  --v-input-control-height: 48px;
  --v-field-padding-bottom: 0px !important;
}

.app-date-field__input :deep(.v-messages__message) {
  color: #dc2626 !important;
  font-size: 13px;
}
</style>
